// extracted by mini-css-extract-plugin
export default {"graph-header-area":"histogram_graph-header-area__03J6Q"};